import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bgImage from "./bracu_image.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pin, setPin] = useState("");
  const [role] = useState("faculty"); // fixed role
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long.");
      return;
    }

    // ✅ PIN validation: 1–8 digits, leading zeros allowed
    const pinRegex = /^\d{1,8}$/;
    if (!pinRegex.test(pin)) {
      toast.error("PIN must contain 8 digits (numbers only).");
      return;
    }

    try {
      const res = await axios.post(
        "https://api.bbsfacultyprofile.com/api/register",
        {
          email,
          password,
          role,
          pin,
        }
      );

      if (res.status === 201) {
        toast.success("Registration successful!");

        // Delay navigation by 2–3 seconds to allow the toast to show
        setTimeout(() => {
          navigate("/login");
        }, 2500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          padding: "40px",
          borderRadius: "12px",
          width: "350px",
          boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          User Registration
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column" }}
        >
          Email:
          <input
            type="email"
            placeholder="Email (@bracu.ac.bd)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={inputStyle}
          />
          Password:
          <input
            type="password"
            placeholder="Password (min 6 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={inputStyle}
          />
          PIN:
          <input
            type="text"
            placeholder="Enter PIN (8 digits). Begin with 0's if needed."
            value={pin}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value)) {
                setPin(e.target.value);
              }
            }}
            maxLength={8}
            inputMode="numeric"
            required
            style={inputStyle}
          />
          Role:
          <select value={role} disabled style={inputStyle}>
            <option value="faculty">Faculty</option>
          </select>
          <button
            type="submit"
            style={{
              backgroundColor: "#4d3aa1ff",
              color: "white",
              padding: "10px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              marginTop: "10px",
              fontWeight: "bold",
            }}
          >
            Register
          </button>
        </form>

        <p style={{ marginTop: "15px", textAlign: "center" }}>
          Already have an account?{" "}
          <button onClick={() => navigate("/login")} style={linkButtonStyle}>
            Login
          </button>
        </p>

        <p style={{ textAlign: "center", marginTop: "10px" }}>
          <button onClick={() => navigate("/")} style={linkButtonStyle}>
            Back to Home
          </button>
        </p>
      </div>

      <ToastContainer position="top-center" autoClose={3000} theme="colored" />
    </div>
  );
}

// 🔹 Reusable styles
const inputStyle = {
  padding: "10px",
  margin: "10px 0",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const linkButtonStyle = {
  background: "none",
  border: "none",
  color: "#2196F3",
  cursor: "pointer",
  fontWeight: "bold",
  textDecoration: "underline",
};
